import React, { useContext } from 'react'
import DetailsBox from '../../../../../components/Cards/DetailsBox'
import Alert from '@mui/material/Alert'
import Grid from '@mui/material/Grid'
import { TenantSettingsContext, UserContext } from '../../../../../App'
import EMP from '../../../../events/SingleEvent/DocumentGenerator/EMP'
import { Stack } from '@mui/material'

const MedicalPlan = ({ event }) => {
  const { user } = useContext(UserContext)
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig
  return (
    <Grid item xs={12}>
      <DetailsBox title="Medical Plan">
        {!event.EMPApproved && !event.draftEMPVisibleByClient ? (
          <Alert severity="info">Medical Plan is not available yet.</Alert>
        ) : (
          <Stack gap={1}>
            {!event.EMPApproved && (
              <Alert severity="warning">
                Please be aware that the Medical Plan is currently in Draft
                state
              </Alert>
            )}
            <EMP
              user={{
                firstName: user.firstName,
                lastName: user.lastName,
              }}
              status={event.EMPApproved ? 'Approved' : 'Draft'}
              eventID={event._id}
              orgSettings={orgSettings}
            />
          </Stack>
        )}
      </DetailsBox>
    </Grid>
  )
}

export default MedicalPlan
